import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetCountry():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Country/Get`);
  }

  DeleteCountry(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Country/Delete?id=${id}`);
  }

  CreateCountry(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Country/Create`,data);
  }
  UpdateCountry(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Country/Update`,data)
  }
}
